export default __webpack_public_path__ + "static/media/Thug's Bracers of the Grim Cabal.0ba74b04.jpg";